import Flex from './Flex';

export default Flex;
